import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Navbar from "../../Components/Navbar";
import top_banner from "../../Assets/Images/individual_banner.png";
import green_circle from "../../Assets/Images/green_circle.png";
import num from "../../Assets/Images/num.png";
import CopyRight from "../../Components/CopyRight";
import Footer from "../../Components/Footer";
import IndividualForm from "./IndividualForm";


const Individual = () => {
  return (
    <Box    sx={{
      "& .bin_2": {
        background: "transparent",
        color: "#fff",
        "& input[type=number]": {
          "-moz-appearance": "textfield",
        },
        "& input[type=number]::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "& input[type=number]::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&:focus-Visible": {
          outline: "none !important",
          border: "none !important",
        },
        "&:hover": {
          border: "none",
        },
        "& .MuiInputBase-root": {
          "&::before": {
            display: "none",
          },
          "&::after": {
            display: "none",
          },
        },

        "&:focus": {
          boxShadow: "none !important",
          border: "1px solid #fff !important",
          borderRadius: "8px !important ",
        },
        "& input": {
          padding: "0px",
          // width: "100%",
          color: "#000",
          borderBottom: "1px solid",
          height: "28px",
          "&:focus": {
            outline: "none",
          },
          "&::placeholder": {
            color: "#0000008f !important",
            fontFamily: "myriadRegular",
          },
        },
      },
    
    }}>
      <Box position={"relative"}>
        <Typography
          component={"img"}
          src={green_circle}
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            width: { sm: "60%", xs: "90%" },
            height: "100%",
          }}
        />
        <Navbar />

        <Box
          sx={{
            position: "relative",
          }}
        >
          <Typography
            component={"img"}
            src={top_banner}
            sx={{
              width: "100%",
              height: { sm: "auto", xs: "60vh" },
              objectFit: "cover",
            }}
          />

          <Box
            sx={{
              width: "100%",
              position: "absolute",
              top: { md: "50%", xs: "30%" },
              transform:{md:"translateY(-50%)",xs:"translateY(-30%)"},
              right: "0",
            }}
          >
            <Container sx={{
                display:"flex",
                justifyContent:"flex-end"
            }}>
              <Box
                sx={{
                //   width: { md: "600px", xs: "100%" },
                  textAlign: { md: "start", xs: "start" },
                  "& p":{
                    fontSize: { md: "30px", xs: "20px" },
                    color: "rgba(247, 235, 247, 1)",
                    lineHeight:"normal",
                    pb:"1.5rem"
                  }
                }}
              >
                <Typography
                  sx={{
                    fontSize: { md: "35px !important", xs: "20px !important" },
                    fontWeight:"600"
                  }}
                >
              CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> Services
                </Typography>
                <Typography>
                Find out about breathing habits <br/>that impact your CO<sub>2</sub> levels.
                </Typography>
                 
                <Typography>
                Learn more about how breathing habits can <br />affect respiration and wellness specific to you.
                </Typography>
              
         
              </Box>
            </Container>
          </Box>
        </Box>
        <Container>
        <Grid container spacing={1}>
            <Grid item md={1} xs={1} sx={{
                alignSelf:"center",
                height:"100%",
                position:"relative",
                "& img":{
                    background:"#e2fceb"
                }
            }}>
            <Typography component={"img"} src={num} width={"100%"}/>
            </Grid>
            <Grid item md={11} xs={11}>
            <Box
            sx={{
              py: "5rem",
              position: "relative",
            }}
          >
            <Typography
              sx={{
                fontSize: { sm: "35px", xs: "25px" },
                color: "#000",
                pb:"2rem"
              }}
            >
              How are your breathing habits affecting you?
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "35px", xs: "25px" },
                color: "#000",
                pb:"3rem"
              }}
            >
          Information To Get Started.
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                color: "#000",
                pb:"2rem"
              }}
            >
            
              Click on the “schedule me” button below for an initial appointment.  Discover how CapnoLearning<sup style={{ fontSize: "8px" }}>TM </sup>{" "}services can benefit you.
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                color: "#000",
                pb:"1.5rem"
              }}
            >
           <b>INDIVIDUALS</b>
           <br/>
           Experience a 25-minute CapnoLearning<sup style={{ fontSize: "8px" }}>TM</sup> Breathing Habit Interview (without instrumentation).
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                color: "rgba(122, 123, 145, 1)",
                pb:"1.5rem"
              }}
            >
          During your appointment find out more about your breathing habits, the effects relevant to respiration, and more about when your breathing could be disrupting respiration.  
            </Typography>
            <Typography
              sx={{
                fontSize: { sm: "25px", xs: "20px" },
                color: "rgba(122, 123, 145, 1)",
                pb:"3rem"
              }}
            >
        Based on the initial interview, and when you are a candidate who is likely to benefit, additional service options become available. Click on the inquiry button below to get started. We will reach out to you by email to schedule an initial appointment.
            </Typography>
        
          <IndividualForm/>
         
          </Box>
            </Grid>
        </Grid>
          
        </Container>
      </Box>
    
      
      <Footer/>
      <CopyRight />
    </Box>
  );
};

export default Individual;
